class EstimatedProfits {
    forRetailPrice;
    forBestPrice;
    constructor(data) {
        this.forRetailPrice = data.forRetailPrice;
        this.forBestPrice = data.forBestPrice;
    }
}
export default EstimatedProfits;
